/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_field_v2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Final volume (V2)`)
};

const es_soldil_field_v2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen final (V2)`)
};

const de_soldil_field_v2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endvolumen (V2)`)
};

const nl_soldil_field_v2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eindvolume (V2)`)
};

const fr_soldil_field_v2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume final (V2)`)
};

const it_soldil_field_v2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume finale (V2)`)
};

const pt_br2_soldil_field_v2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume final (V2)`)
};

const pt_soldil_field_v2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume final (V2)`)
};

const ja_soldil_field_v2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終体積 (V2)`)
};

const zh_soldil_field_v2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`终体积（V2）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_field_v2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_field_v2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_field_v2", locale)
	if (locale === "en") return en_soldil_field_v2(inputs)
	if (locale === "es") return es_soldil_field_v2(inputs)
	if (locale === "de") return de_soldil_field_v2(inputs)
	if (locale === "nl") return nl_soldil_field_v2(inputs)
	if (locale === "fr") return fr_soldil_field_v2(inputs)
	if (locale === "it") return it_soldil_field_v2(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_field_v2(inputs)
	if (locale === "pt") return pt_soldil_field_v2(inputs)
	if (locale === "ja") return ja_soldil_field_v2(inputs)
	return zh_soldil_field_v2(inputs)
};